import React, { useEffect, useMemo } from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "../../../styles/main.css"
import i18n from "../../../i18n"
import { Provider } from "react-redux"
import { store } from "../../../app"
import RootLayout from "../../../shared/Layouts/RootLayout"

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("bundle-list")
  if (node) {
    const props = JSON.parse(node.getAttribute("data-props") || "{}")

    if (props.locale) {
      i18n.changeLanguage(props.locale)
    }

    const root = createRoot(node)
    root.render(
      <Provider store={store}>
        <RootLayout themeName={props?.themeName ?? "default"}>
          <App {...props} />
        </RootLayout>
      </Provider>
    )
  }
})
